import { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faCogs,
  faList,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import Dropdown from "react-bootstrap/Dropdown";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";

import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import ObjectivesList from "../Components/ObjectivesList";
import TeamMembersList from "../Components/TeamMembersList";
import { useTranslation } from "react-i18next";
import axios from "axios";
import "./MyObjectives.css";

function MyObjectives() {
  const [isLoading, setIsLoading] = useState(true);
  const [objectives, setObjectives] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const [invited, setInvited] = useState([]);

  const { state } = useContext(AuthContext);

  const [key, setKey] = useState("MyObjectives");

  const { t } = useTranslation();

  const location = useLocation();

  const tabKey = location.state?.tabKey;

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/objectives/user/${state.userId}`,
        data: {
          status: "active",
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setObjectives(response.data.objectives);
      setTeamMembers(response.data.teamMembers);
      setInvited(response.data.invited);
      setKey(tabKey);
      setIsLoading(false);
    }
    fetch();
  }, [state.token, state.userId, tabKey]);

  const showActiveObjectives = async () => {
    setIsLoading(true);
    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_BACKEND_URL}/objectives/user/${state.userId}`,
      data: {
        status: "active",
      },
      headers: {
        Authorization: `Bearer ${state.token}`,
      },
    });
    setObjectives(response.data.objectives);
    setTeamMembers(response.data.teamMembers);
    setIsLoading(false);
  };

  const showCompletedObjectives = async () => {
    setIsLoading(true);
    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_BACKEND_URL}/objectives/user/${state.userId}`,
      data: {
        status: "completed",
      },
      headers: {
        Authorization: `Bearer ${state.token}`,
      },
    });
    setObjectives(response.data.objectives);
    setTeamMembers(response.data.teamMembers);
    setIsLoading(false);
  };

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row className="align-items-center">
          <Col lg={11} className="objectives-header">
            <h2>{t("Objetivos.Titulo")}</h2>
          </Col>
          <Col lg={1} className="right objectives-content">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                <FontAwesomeIcon icon={faList} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item as={Link} to={`/objectives/new`}>
                  <FontAwesomeIcon icon={faPlus} />{" "}
                  {t("Objetivos.NuevoObjetivo")}
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item onClick={showActiveObjectives}>
                  <FontAwesomeIcon icon={faCogs} />{" "}
                  {t("Objetivos.ObjetivosActivos")}
                </Dropdown.Item>
                <Dropdown.Item onClick={showCompletedObjectives}>
                  <FontAwesomeIcon icon={faCheck} />{" "}
                  {t("Objetivos.ObjetivosCerrados")}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
        <Row>
          <Tabs activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
            <Tab
              eventKey="MyObjectives"
              title={t("Objetivos.MisObjetivos.Titulo")}
            >
              <Row>
                {objectives.length === 0 ? (
                  <Col className="empty-objectives center">
                    <h5>{t("Objetivos.SinObjetivos")}</h5>
                  </Col>
                ) : (
                  <ObjectivesList
                    objectives={objectives}
                    language={state.language}
                  />
                )}
              </Row>
            </Tab>
            <Tab eventKey="MyTeam" title={t("Objetivos.MiEquipo")}>
              <Row>
                {teamMembers.length === 0 ? (
                  <Col className="empty-objectives center">
                    <h5>{t("Objetivos.SinObjetivos")}</h5>
                  </Col>
                ) : (
                  <TeamMembersList
                    teamMembers={teamMembers}
                    language={state.language}
                  />
                )}
              </Row>
            </Tab>
            <Tab eventKey="Invited" title={t("Objetivos.Invitado")}>
              <Row>
                {invited.length === 0 ? (
                  <Col className="empty-objectives center">
                    <h5>{t("Objetivos.SinObjetivos")}</h5>
                  </Col>
                ) : (
                  <TeamMembersList
                    teamMembers={invited}
                    language={state.language}
                  />
                )}
              </Row>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    );
  }
}

export default MyObjectives;
